import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GameService } from '@services';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-team-image-modal',
  templateUrl: './team-image-modal.component.html',
  styleUrls: ['./team-image-modal.component.scss'],
  imports: [
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
})
export class TeamImageModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { teamControl: AbstractControl },
    public gameService: GameService,
    private dialogRef: MatDialogRef<TeamImageModalComponent>,
  ) {}

  private _initialValues = this.data.teamControl.value;

  ngOnInit(): void {
    this.dialogRef
      .backdropClick()
      .subscribe(() => this.data.teamControl.reset(this._initialValues));
  }

  closeModal(saveChanges: boolean): void {
    if (saveChanges) {
      this.data.teamControl
        .get('team_name_lowercase')
        .patchValue(this.data.teamControl.get('team_name').value.toLowerCase());
      this.dialogRef.close(this.data.teamControl);
      return;
    }
    this.data.teamControl.reset(this._initialValues);
    this.dialogRef.close();
  }

  deleteImage() {
    this.data.teamControl.get('image').setValue(null);
    this.data.teamControl.markAsDirty();
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  get image() {
    return this.data.teamControl.get('image').value;
  }
}
